import { apiSlice } from "../apiSlice/apiSlice";

export const quizMark = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllQuizMark: builder.query({
            query: () => '/quizMark'
        }),
        getQuizMarkWithStudentIdAndVideoId: builder.query({
            query: ({ studentId, videoId }) => {
                return `/quizMark?video_id=${videoId}&student_id=${studentId}`
            }
        }),
        submitQuiz: builder.mutation({
            query: (info) => {
                const user = info.user || {}
                const quiz = info.quiz || {}
                const quizResult = info.quizResult || {}

                const perCorrectMark = 5;
                const totalQuiz = quizResult.length;
                const totalCorrect = quizResult.filter(single => single.isCorrect === true).length

                const data = {
                    student_id: user.id,
                    student_name: user.name,
                    video_id: quiz.video_id,
                    video_title: quiz.video_title,
                    totalQuiz,
                    totalCorrect,
                    totalWrong: totalQuiz - totalCorrect,
                    totalMark: perCorrectMark * totalQuiz,
                    mark: totalCorrect * perCorrectMark
                }

                return {
                    url: '/quizMark',
                    method: "POST",
                    body: data,
                }
            },
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                const result = await queryFulfilled;
                const { data } = result || {}

                const query = { videoId: data.video_id, studentId: data?.student_id }
                // update data 
                dispatch(apiSlice.util.updateQueryData(
                    "getQuizMarkWithStudentIdAndVideoId",
                    query,
                    (draft) => {
                        draft.push(data);
                    }
                )
                );
                dispatch(apiSlice.util.updateQueryData(
                    "getAllQuizMark",
                    undefined,
                    (draft) => {
                        draft.push(data);
                    }
                )
                );

            }
        }),
        ediQuizMark: builder.mutation({
            query: (info) => {
                const user = info.user || {}
                const quiz = info.quiz || {}
                const quizResult = info.quizResult || {}

                const perCorrectMark = 5;
                const totalQuiz = quizResult.length;
                const totalCorrect = quizResult.filter(single => single.isCorrect === true).length
                const data = {
                    student_id: user.id,
                    student_name: user.name,
                    video_id: quiz.video_id,
                    video_title: quiz.video_title,
                    totalQuiz,
                    totalCorrect,
                    totalWrong: totalQuiz - totalCorrect,
                    totalMark: perCorrectMark * totalQuiz,
                    mark: totalCorrect * perCorrectMark
                }
                return {
                    url: `/quizMark/${info.id}`,
                    method: "PATCH",
                    body: data
                }
            },
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                const result = await queryFulfilled;
                const { data } = result || {};

                // update data   
                dispatch(apiSlice.util.updateQueryData(
                    'getQuizMarkWithStudentIdAndVideoId',
                    { studentId: data.student_id, videoId: data.video_id },
                    (draft) => {
                        draft[0] = data
                    }
                ))

            }
        }),

    })
})
export const { useGetAllQuizMarkQuery, useGetQuizMarkWithStudentIdAndVideoIdQuery, useSubmitQuizMutation, useEdiQuizMarkMutation } = quizMark;